module.exports = __webpack_public_path__ + "img/Terraform-3-mobile.2cce71e1.png";